import styled from 'styled-components';

// /signup (definicao de senha no primeiro acesso) reusa o shell visual do
// /login — mesmo padrao do /forgot-password. O layout legado usava
// posicionamento absoluto fragil (Title com bottom: 470px) que quebrava em
// resolucoes/zoom diferentes; o shell e grid responsivo + tokens CCO.
export {
  Stage,
  BrandSide,
  BrandBg,
  BrandOverlay,
  BrandTop,
  BrandMark,
  BrandHero,
  Eyebrow,
  HeroTitle,
  HeroLead,
  BrandFoot,
  FormSide,
  FormWrap,
  FormHead,
  FormHeadLbl,
  FormTitle,
  FormSub,
  Form,
  Field,
  FieldLabel,
  Ctrl,
  ToggleEye,
  Hint,
  Submit,
  FormFoot,
  Vers,
} from '../login/styled-login';

// Checklist ao vivo dos criterios de senha (substitui o TipPassword
// flutuante). Cada regra acende verde conforme a senha digitada atende.
export const RuleList = styled.ul`
  list-style: none;
  margin: 2px 0 0;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border: 1px solid var(--cco-line);
  border-radius: 10px;
  background: var(--cco-soft-surface);
`;

export const RuleItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => (props.$ok ? 'var(--cco-green)' : 'var(--cco-ink-faint)')};
  transition: color 150ms;

  > svg {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
  }
`;

// Link discreto "Voltar ao login" — mesmo padrao do BackToLogin do forgot.
export const BackToLogin = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
  background: transparent;
  border: none;
  color: var(--cco-ink-faint);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: color 150ms;

  > svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    color: var(--cco-ink);
  }
`;
